import React, {useEffect, useState} from "react";
import {LoggedInView} from "../common/LoggedInView";
import {useAppDispatch} from "../../utils/Hooks";
import {TopClientsTable} from "./components/TopClientsTable";
import {getTopClients} from "../../store/reducers/ClientsSlice";
import TopClientsSearch from "./components/TopClientsSearch";
import {useParams} from "react-router-dom";

interface TopClientsScreeProps {
}

export const TopClientsScreen: React.FC<TopClientsScreeProps> = () => {

    const dispatch = useAppDispatch();
    const routeParams = useParams();

    const [fromDate, setFromDate] = useState<string>();
    const [toDate, setToDate] = useState<string>();

    useEffect(() => {

        const urlParams = new URLSearchParams(window.location.search);

        setFromDate(urlParams.get("fromDate") || '');
        setToDate(urlParams.get("toDate") || '');

        dispatch(getTopClients());
    }, [routeParams]);

    return (
        <LoggedInView fullWidth={false}>
            <h1>Top kliendid {fromDate} - {toDate}</h1>
            <TopClientsSearch />
            <TopClientsTable fromDate={String(fromDate)} toDate={String(toDate)} />
        </LoggedInView>
    )

}